import React from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';

const OfflineView = () => {
  const { t } = useTranslate();
  return (
    <OfflineContainer id="offline">
      <OfflineMessage>
        <h1>{t('profile.not_connected')}</h1>
      </OfflineMessage>
    </OfflineContainer>
  );
};

export default OfflineView;

const OfflineContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: flex-start; /* Message stays at the top */
  justify-content: center;
  background-color: rgba(0, 0, 0, 0); /* Dark semi-transparent overlay */
  backdrop-filter: blur(5px); /* Strong blur effect */
  z-index: 9999;
`;

const OfflineMessage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: ${({ theme }) => theme.menu.deleteColor};
  text-align: center;

  h1 {
    font-size: 14px;
    font-weight: 500;
    color: white;
    margin: 0;
  }
`;
